import { render, staticRenderFns } from "./MyLink.vue?vue&type=template&id=314342f8&scoped=true&"
import script from "./MyLink.vue?vue&type=script&lang=js&"
export * from "./MyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314342f8",
  null
  
)

export default component.exports